// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__s3uns","description":"PatientConsentPreview_description__1ZGtq"};